import React from "react";
import { calculatePageNumbers } from "../../../../utils/helper";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

// Page component map for preview that matches actual PDF structure
const previewPageComponentMap = {
  "Overview": [{ component: "Overview" }],
  "Summary Snapshot": [{ component: "AboutReport" }],
  "Starter Quadrant": [{ component: "HomeFirst" }],
  "Four Quadrants": [{ component: "FourQuadrantPage" }],
  "Starter Quadrant Chart": [{ component: "StarterQuadrantChart" }],
  "Results": [{ component: "HeartStarter" }],
  "HomeQuadrantFlow": [{ component: "QuadrantFlowHome" }],
  "Introduction": [{ component: "QuadrantFlowPage1" }],
  "Quadrant Flow": [{ component: "QuadrantFlowPage2" }],
  "QFItemOnePage": [
    { component: "AccToPageHeading" },
    { component: "AccToPageHeadingTwo" }
  ],
  "Heart": [{ component: "HeartPage" }],
  "Soul": [{ component: "SoulPage" }],
  "Mind": [{ component: "MindPage" }],
  "Strength": [{ component: "StrengthPage" }],
  "Home Leadership Style": [{ component: "LeadershipPage1" }],
  "Leadership Style Introduction": [{ component: "LeadershipPage2" }],
  "Leadership Style Chart": [{ component: "LeadershipPage3" }],
  "Leadership Style Results": [{ component: "LeadershipStyleCollaborative360" }],
  "Leadership Flow Introduction": [{ component: "LeadershipFlow" }],
  "Leadership Flow Results": [{ component: "LeaderFlowDetails" }],
  "Items Overview": [
    { component: "LeaderItemsOverview" },
    { component: "LeadItemTwoOverview" }
  ],
  "Collaborative": [{ component: "CollaborativePage" }],
  "Visionary": [{ component: "VisionaryPage" }],
  "Strategic": [{ component: "StrategicPage" }],
  "Performance": [{ component: "PerformancePage" }],
  "Alignment": [
    { component: "GapAnalysisPage" },
    { component: "GapAnalysisPageTwo" }
  ],
  "Home Mindset": [{ component: "HomeMinset" }],
  "Mindset Introduction": [
    { component: "MindSetPage" },
    { component: "MindsetImagePage" }
  ],
  "Mindset Results": [{ component: "MindSetPage3" }],
  "Home Reflect And Integrate": [{ component: "RelectAndIntegrate1" }],
  "Reflect and Integrate": [{ component: "RelectAndIntegrate2" }],
  "Life Integration": [{ component: "LifeIntegration1" }],
  "Leadership Integration": [{ component: "LifeIntegration3" }],
  "Final Thoughts": [{ component: "LifeIntegration2" }]
};

const styles = {
  coverSection: {
    textAlign: "left",
    alignItems: "flex-start",
    fontFamily: "Helvetica, sans-serif",
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
    paddingTop: "0px",
    marginBottom: "60%",
    margin: "0px",
    paddingTop: "12px"
  },
  coverTitle: {
    marginBottom: "12px",
    fontSize: "18px",
    fontWeight: 700,
    fontStyle: "Bold",
    lineHeight: "24px",
    letterSpacing: "0px",
    color: "#00577D",
    textAlign: "left",
    textTransform: "uppercase",
    fontFamily: "Helvetica, sans-serif",
  },
  tocSection: {
    width: "100%",
    paddingLeft: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0px",
  },
  tocItem: {
    fontFamily: "Helvetica, sans-serif",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: 'calc(100% - 10px)',
    fontSize: "14px",
    fontWeight: 700,
    fontStyle: "Bold",
    lineHeight: "40px",
    letterSpacing: "0px",
    textTransform: "uppercase",
    color: "#000000",
  },
  tocNumber: {
    fontWeight: 600,
  },
};


const TableContentPreview = ({ tocSections, tocPageNumbers, menuItems, pageNumber, reportType, apiData }) => {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)"}}>
      <HeaderPreview apiData={apiData} />
      <div style={styles.coverSection}>
        <div style={styles.coverTitle}>TABLE OF CONTENTS</div>
        <div style={styles.tocSection}>
          {tocSections && tocSections.map((section, index) => (
            <div key={index} style={styles.tocItem}>
              <span>{`${index + 1}. ${section.label}`}</span>
              <span style={styles.tocNumber}>{(tocPageNumbers?.[index] ?? 0).toString().padStart(2, '0')}</span>
            </div>
          ))}
        </div>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
};

export default TableContentPreview;
